import { useBoolean } from 'usehooks-ts';

import { DocumentActionItem } from '@/components/Form/ActionList/DocumentActionItem';

import { useDrawerOpenTracker } from '@/context';

import { useTranslate } from '@/hooks/useTranslate';

import { DocumentStatus } from '@/types/document';

import { useYourFinancesStatus } from './hooks';
import { YourFinancesDrawer } from './YourFinancesDrawer';

export function YourFinances() {
  const { t } = useTranslate();
  const { isVisible, isComplete, isLoading, currentQuestion } =
    useYourFinancesStatus();
  const {
    value: isDrawerOpen,
    setTrue: openDrawer,
    setFalse: closeDrawer,
  } = useBoolean(false);

  useDrawerOpenTracker(isDrawerOpen);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <DocumentActionItem
        title={t('moreInfo.form.yourFinances.title')}
        description={t('status.pending')}
        onClick={openDrawer}
        disabled={isLoading}
        status={isComplete ? DocumentStatus.Completed : DocumentStatus.Pending}
      />
      <YourFinancesDrawer
        open={isDrawerOpen}
        onClose={closeDrawer}
        isLoading={isLoading}
        currentQuestion={currentQuestion}
      />
    </>
  );
}
